<template>
	<a-dropdown v-if="currentUser && currentUser.name" placement="bottomRight">
		<span class="ant-pro-account-avatar">
			<span style="font-size: 12px; margin-right: 20px">上次登录时间：{{ logindate }}</span>
			<a-avatar size="small" :src="src" class="antd-pro-global-header-index-avatar" />
			<span>{{ nickname }}</span>
		</span>
		<template v-slot:overlay>
			<a-menu class="ant-pro-drop-down menu" :selected-keys="[]">
				<a-menu-item v-if="menu" key="settings" @click="handleToSettings">
					<a-icon type="setting" />{{ i18nRender('menu.account.center') }}
				</a-menu-item>
				<a-menu-divider v-if="menu&&types==0" />
				<a-menu-item v-if="menu&&types==0" key="share-alt" @click="handleToQuotation">
					<a-icon type="share-alt" />{{ i18nRender('switch') }}
				</a-menu-item>
				<a-menu-divider v-if="menu&&types==1" />
				<a-menu-item v-if="menu&&types==1" key="share-alt" @click="handleToAnlian">
					<a-icon type="share-alt" />{{ i18nRender('Cloud') }}
				</a-menu-item>
				<a-menu-divider v-if="menu" />
				<a-menu-item key="logout" @click="handleLogout">
					<a-icon type="logout" />{{ i18nRender('logout') }}
				</a-menu-item>
			</a-menu>
		</template>
	</a-dropdown>
	<span v-else>
		<a-spin size="small" :style="{ marginLeft: 8, marginRight: 8 }" />
	</span>
</template>

<script>
	import {
		Modal
	} from 'ant-design-vue'
	import {
		mapActions,
		mapGetters
	} from 'vuex'
	import {
		i18nRender
	} from '@/locales'
	import Cookies from 'js-cookie'
	export default {
		name: 'AvatarDropdown',
		props: {
			currentUser: {
				type: Object,
				default: () => null,
			},
			menu: {
				type: Boolean,
				default: true,
			},
		},
		computed: {
			...mapGetters(['nickname', 'avatar']),
		},
		data() {
			return {
				src: process.env.VUE_APP_API_BASE_URL + '/file/file/pre_file?bucketName=avatar&path=/' + this.$store.getters.avatar,
				logindate: '',
				types: 0,
			}
		},
		created() {
			
			this.logindate = this.$store.getters.userInfo.loginLast
			console.log(this.logindate, 'this.logindate===================')
			var a = window.location.pathname
			console.log(window.location.pathname, 'this.$router.path===================')
			if(a.indexOf('Quotation') != -1){
				this.$store.commit('SET_NAV', 1)
				this.types = 1
				console.log(a.indexOf('Quotation') , a.indexOf('Quotation') ,'11111111111111111')
				console.log(this.$store.commit('SET_NAV', 1),'SET_NAVSET_NAVSET_NAVSET_NAVSET_NAVSET_NAV')
				// this.handleToQuotation()
			} else{
				this.$store.commit('SET_NAV', 0)
				console.log('SET_NAV','SET_NAVSET_NAVSET_NAVSET_NAVSET_NAVSET_NAV')
				
				

			}
		},
		methods: {
			...mapActions(['Logout']),
			handleToCenter() {
				this.$router.push({
					path: '/account/center'
				})
			},
			handleToSettings() {
				this.$router.push({
					path: '/settings/base'
				})
			},
			// parametersetting
			handleToQuotation() {
				this.$store.commit('SET_NAV', 1);
				this.$router.push({
					path: '/Quotation/post'
				})
				this.types = 1
			},
			handleToAnlian() {
				this.$store.commit('SET_NAV', 0)
				this.$router.push({
					path: '/dashboard/weclome'
				})
				this.types = 0
			},
			handleLogout(e) {
				Modal.confirm({
					title: this.$t('layouts.usermenu.dialog.title'),
					content: this.$t('layouts.usermenu.dialog.content'),
					onOk: () => {
						return this.Logout({})
							.then(() => {
								setTimeout(() => {
									this.$router.push({
										name: 'login',
									})
								}, 16)
							})
							.catch((err) => {
								this.$message.error({
									title: '错误',
									description: err.message,
								})
							})
					},
					onCancel() {},
				})
			},
			i18nRender(key) {
				return i18nRender(key)
			},
		},
	}
</script>

<style lang="less" scoped>
	.ant-pro-drop-down {
		/deep/ .action {
			margin-right: 8px;
		}

		/deep/ .ant-dropdown-menu-item {
			min-width: 160px;
		}
	}
</style>
